<template>
    <x-modal :id="id" title="Tambah Validation Rule Baru">
        <validation-rule-form id="validation-rule-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            v-if="renderForm" />
        <template #footer>
            <x-submit-button form="validation-rule-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
            <x-close-modal-button :disabled="isLoading" />
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from '../../components/XCloseModalButton.vue'
import XModal from '../../components/XModal.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleValidationXhrError } from '../../helpers'
import ValidationRuleForm from '../validation-rule/ValidationRuleForm.vue'

export default {
    components: {
        ValidationRuleForm,
        XModal,
        XSubmitButton,
        XCloseModalButton,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            renderForm: true,
        }
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.post(`/api/validation-rules`, fields)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} added!`,
                    })
                    this.$emit('created', response.data.data)
                    $(`#${this.id}`).modal('hide')
                    this.resetFields()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        },
        resetFields() {
            this.renderForm = false
            setTimeout(() => {
                this.renderForm = true
            }, 10)
        },
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>